import styled from 'styled-components'

const StCardButton = styled.button<{
  roundedTop?: boolean
  roundedBottom?: boolean
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  ${({ theme, roundedTop, roundedBottom }) => {
    const cardTheme = theme.Components.Card

    return `
      color: ${theme.Colors.Neutrals.Darkest};
      background-color: ${cardTheme.Fill};
      border: 1px solid ${cardTheme.Border};

      border-top-left-radius: ${roundedTop ? theme.UI.BorderRadius.Large : 0}px;
      border-top-right-radius: ${roundedTop ? theme.UI.BorderRadius.Large : 0}px;
      border-bottom-left-radius: ${roundedBottom ? theme.UI.BorderRadius.Large : 0}px;
      border-bottom-right-radius: ${roundedBottom ? theme.UI.BorderRadius.Large : 0}px;

      padding: ${theme.UI.SpacingPx.Space4};

      transition: all 250ms ease-out;

      &:active {

        background-color: ${cardTheme.ActiveFill};
        border: 1px solid ${cardTheme.ActiveBorder};
      }

      &:disabled {

        background-color: ${cardTheme.DisabledFill};
        border: 1px solid ${cardTheme.DisabledBorder};
      }
    `
  }};
`

export { StCardButton }
